import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  baseUrl: 'https://mgmt-api.tokencontrol.ai/v1/',
  // baseUrl: 'https://localhost:44305/v1/',
  clientId: '223f56ec-09c2-4b08-b484-3e24c518d50c',
  frontendUrl: 'https://app.tokencontrol.ai',
  // frontendUrl: 'http://localhost:4200',
  microsoftGraphUserEndpoint: 'https://graph.microsoft.com/v1.0/users/',
  authenticationMethodResetPath: '/authentication/methods/28c10230-6103-485e-b985-444c60001490/resetPassword/',
  defaultThemeName: 'white-duck',
  // costControlProxyUrl: 'http://localhost:5196',
  costControlProxyUrl: 'https://api.tokencontrol.ai',
};
